import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthenticationService } from '../../authentication.service';
import { ModalComponent } from '@styleguide/modal/modal/modal.component';
import { ModalHeaderComponent } from '@styleguide/modal/modal-header/modal-header.component';
import { ModalContentComponent } from '@styleguide/modal/modal-content/modal-content.component';
import { AsyncPipe } from '@angular/common';
import { LoginFormComponent } from '../login-form/login-form.component';

@Component({
  selector: 'kgr-layer-login',
  templateUrl: './layer-login.component.html',
  styleUrls: ['./layer-login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ModalComponent, ModalHeaderComponent, ModalContentComponent, LoginFormComponent, AsyncPipe],
})
export class LayerLoginComponent implements OnInit {
  open$ = this.authenticationService.loginLayerIsOpen$;

  constructor(private authenticationService: AuthenticationService) {}

  ngOnInit() {}

  onLoginResult(success: boolean) {
    if (this.authenticationService.loginLayerIsOpen$.getValue()) {
      this.authenticationService.loginLayerResult.next(success);
    }
  }

  onClose() {
    if (this.authenticationService.loginLayerIsOpen$.getValue()) {
      this.authenticationService.loginLayerResult.next(false);
    }
  }
}
